import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, licenciamentoVeiculo } from './types';

export const INITIAL_STATE: licenciamentoVeiculo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): licenciamentoVeiculo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.LICENCIAMENTO_VEICULO_REQUEST: {
				break;
			}

			case Types.LICENCIAMENTO_VEICULO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.LICENCIAMENTO_VEICULO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.LICENCIAMENTO_VEICULO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
